import { render } from "./SampleAckOrders.vue?vue&type=template&id=77378ed8"
import script from "./SampleAckOrders.vue?vue&type=script&lang=js"
export * from "./SampleAckOrders.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/orders/SampleAckOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77378ed8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77378ed8', __exports__)) {
    console.log('reload')
    api.reload('77378ed8', __exports__)
  }
  
  module.hot.accept("./SampleAckOrders.vue?vue&type=template&id=77378ed8", () => {
    console.log('re-render')
    api.rerender('77378ed8', render)
  })

}


export default __exports__